<template>
  <footer>

    <!--// Main column -->
    <div class='base-five border-top padding-top full-width margin-right'>

      <dsMenu v-if='screenSize.mobile || location.single || location["verdieping-programma"] || location["verdieping-mapping"] ||  location["verdieping-links-naar-meer"]'
              :language='language'>
      </dsMenu>

    </div>

  </footer>
</template>

<script>
import dsMenu from './dsMenu'
export default {
  name: 'dsFooter',
  components: {
    dsMenu
  },
  props: ['language', 'location', 'screenSize']
}
</script>

<style lang='scss' scoped>
@import '../styles/helpers/_mixins.scss';
@import '../styles/responsive/_manager.scss';
@import '../styles/_variables.scss';
@import '../styles/_space.scss';
@import '../styles/_color.scss';

footer {
  width: 100%;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// dsFooter.vue?2a4e66fc